module.exports = __webpack_public_path__ + "static/media/gameover.83b7ea5b.png";